import { useCallback, useState } from "react";
import type { ToastItem } from "../components/ToastHost";

const uid = () => Math.random().toString(36).slice(2) + Date.now().toString(36);

export const useToasts = () => {
    const [toasts, setToasts] = useState<ToastItem[]>([]);

    const push = useCallback((type: ToastItem["type"], message: string, title?: string) => {
        const id = uid();
        const item: ToastItem = { id, type, title, message };
        setToasts((prev) => [item, ...prev]);

        // auto-dismiss efter 4.5 sek
        setTimeout(() => {
            setToasts((prev) => prev.filter((x) => x.id !== id));
        }, 4500);
    }, []);

    const dismiss = useCallback((id: string) => {
        setToasts((prev) => prev.filter((x) => x.id !== id));
    }, []);

    return {
        toasts,
        dismiss,
        success: (msg: string, title?: string) => push("success", msg, title),
        error: (msg: string, title?: string) => push("error", msg, title),
        info: (msg: string, title?: string) => push("info", msg, title),
    };
};